import i18next from 'i18next';
import en from './navigation-i18n/en';
import fr from './navigation-i18n/fr';
import config from '../../../config.json';
import defaultUKConfig from './config/ukNavigationConfig';
import defaultCAConfig from './config/canadaNavigationConfig';

i18next.addResourceBundle('en', 'navigation', en);
i18next.addResourceBundle('fr', 'navigation', fr);

const deploymentRegion = config.deploymentRegion || 'uk';

const getNavigationConfig = (region) => {
  if (region === 'canada') {
    return defaultCAConfig;
  }
  return defaultUKConfig;
};

const navigationConfig = getNavigationConfig(deploymentRegion);

export default navigationConfig;
